<template>
  <div class="card-container signin">
    <k-form
      ref="loginForm"
      @submit="handleSubmit"
      :initial-values="formValues"
      :validator="loginValidator"
    >
      <LoginForm :onSubmit="handleSubmit" />
    </k-form>
  </div>
</template>

<script>
import { Form } from "@progress/kendo-vue-form";
import LoginForm from '@/components/forms/LoginForm.vue';
import axios from "axios";
import {useRouter} from "vue-router";
import useUser from '@/composables/user';

const {responseAfterLogin} = useUser();

const loginValidator = (values) => {
  if (!values['user.firstName'] && !values['user.lastName']) {
    return;
  }

  return {
    VALIDATION_SUMMARY: "Please fill at least one of the following fields.",
    ["user.firstName"]:
        "Please check the validation summary for more information.",
    ["user.lastName"]:
        "Please check the validation summary for more information.",
  };
};

export default {
  components: {
    "k-form": Form,
    LoginForm: LoginForm,
  },
  data() {
    return {
      formValues: {
        email: "",
      },
    };
  },
  created() {
    this.setFormValues();
    this.router = useRouter();
  },
  methods: {
    pushToCatalog(resp) {
      const role = resp?.data?.user?.role?.name || null;

      switch(role) {
        case 'client':
        case 'user':
        case '/client':
        case '/user':
          location.href = '/client/orders'
          break;

        case '/supplier':
        case 'supplier':
          location.href = '/supplier/categories'
          break;

        default:
          location.href = '/admin/profile'
      }
    },

    loginValidator: loginValidator,
    async handleSubmit(dataItem) {
      const formValues = JSON.stringify(dataItem, null, 2);
      var self = this;
      axios.post('/api/v1/login', formValues)
          .then(res => {
            this.pushToCatalog(res)
            responseAfterLogin(res);
          })
          .catch(function (error) {
            if (error.response) {
              if (error.response.data.errors) {
                self.$refs.loginForm.form.errors.VALIDATION_SUMMARY = error.response.data.message;
                for (let key in error.response.data.errors) {
                  self.$refs.loginForm.form.errors[key] = error.response.data.errors[key][0];
                }
              } else {
                if (error.response.data.message) {
                  self.$refs.loginForm.form.errors.VALIDATION_SUMMARY = error.response.data.message;
                }
              }
            } else if (error.request) {
              console.log(error.request);
            }
          });
    },
    setFormValues() {
      const form = localStorage.getItem("form");
      if (form) {
        this.formValues = JSON.parse(form);
      }
    },
  },
};
</script>

<style scoped>
.signin {
  margin: 50px auto;
  width: 600px;
  padding: 25px;
}
</style>